<template>
  <div>
    <div v-if="!loading">
      <page-header>
        <template #title>
          <h1 class="page-title">
            Reschedule Job
          </h1>
        </template>
      </page-header>

      <div class="card mb-3">
        <div class="card-body">
          <p>
            The date of a job that has been assigned to a run has been updated.
          </p>
          <p>
            <span
              class="label"
              :class="{
                'label-primary': job.type?.name === 'delivery',
                'label-warning': job.type?.name === 'collection'
              }"
            >
              {{ job.type.label }} </span
            >&nbsp;&nbsp;{{ job.type?.name === 'delivery' ? 'to' : 'from' }}
            {{ job.location }}
          </p>
          <p>
            Date updated from {{ run.date | date }} to {{ job.date | date }}.
          </p>
        </div>
      </div>

      <h4>Current Run</h4>
      <div class="card mb-3">
        <div class="card-body">
          <p>
            The job is currently assigned to {{ run.driver?.full_name }} on
            {{ run.date | date }}.
          </p>

          <div class="list-group">
            <div
              class="list-group-item"
              :key="key"
              v-for="(item, key) in run.items"
            >
              {{ item.job?.type?.label }} - {{ item.job?.location }}
              <span v-if="item.job_id == job.id">
                -
                <form-button
                  type="button"
                  level="danger"
                  :extra-small="true"
                  :indicator="removing"
                  @clicked="removeFromRun"
                  >Remove From Run</form-button
                >
              </span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="runs.length">
        <h4>Assign To Existing Run</h4>
        <p>
          Please check through the runs already created for
          {{ job.date | date }} and select the run you want to assign the run
          to. If you want to create a new run scroll down the "Assign To New
          Run" section.
        </p>

        <div class="card mb-3" :key="key" v-for="(existingRun, key) in runs">
          <div class="card-body">
            <p>
              Assigned to {{ existingRun.driver?.full_name }} on
              {{ existingRun.date | date }}.
            </p>

            <div class="list-group">
              <div
                class="list-group-item"
                :key="itemKey"
                v-for="(item, itemKey) in existingRun.items"
              >
                {{ item.job?.type?.label }} - {{ item.job?.location }}
              </div>
            </div>

            <div class="text-center">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="assignToExistingRun(existingRun)"
              >
                Assign To Run
              </button>
            </div>
          </div>
        </div>
      </div>

      <h4>Assign To New Run</h4>

      <div class="card mb-3">
        <div class="card-body text-center">
          <p>Click the button below to assign the job to a new run.</p>
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="assignJobToNewRun"
          >
            Assign Job To New Run
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <preloader></preloader>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  props: {
    runIdentifier: {
      type: String
    },
    jobIdentifier: {
      type: String
    }
  },

  data() {
    return {
      run: null,
      job: null,
      runs: [],
      loading: true,
      removing: false
    };
  },

  mounted() {
    Promise.all([
      window.Ajax.get(`/runs/${this.runIdentifier}?parts=driver`),
      window.Ajax.get(`/jobs/${this.jobIdentifier}?parts=type,notes`)
    ]).then(([run, job]) => {
      this.run = run.data;
      this.job = job.data;

      const date = window.DateManager.parse(job.data.date);

      window.Ajax.get(
        `/runs?filter[date]=${window.DateManager.format(
          date,
          'YYYY-MM-DD'
        )}&parts=driver`
      ).then(({ data }) => {
        this.runs = data;
        this.loading = false;
      });
    });
  },

  methods: {
    removeFromRun() {
      const run = {
        ...this.run,
        items: this.run.items.filter(item => item.job_id != this.job.id)
      };

      this.removing = true;

      window.Ajax.put(`/runs/${this.runIdentifier}`, run)
        .then(() => {
          this.run.items = this.run.items.filter(
            item => item.job_id != this.job.id
          );

          this.removing = false;

          window.toastify.success(
            'Success',
            'The job was removed from the run successfully'
          );
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'An error occurred while removing the job from the run'
          );

          this.removing = false;
        });
    },

    assignToExistingRun(run) {
      this.$router.push(`/runs/${run.identifier}/edit?job=${this.job.id}`);
    },

    assignJobToNewRun() {
      this.$router.push(
        `/runs/create?job=${this.job.id}&date=${this.job.date}`
      );
    }
  }
};
</script>
